import React from 'react';
import '../styles/components/CtaSection.css';

const CtaSection = () => {
  return (
    <section className="cta-final-section" id="contact">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Transform Your Brand?</h2>
          <p className="cta-subtitle">Let's create signage that makes your business unforgettable</p>
          <div className="cta-features">
            <div className="cta-feature">
              <span>🚀</span>
              <p>Free Design Consultation</p>
            </div>
            <div className="cta-feature">
              <span>⚡</span>
              <p>Same Day Quotes</p>
            </div>
            <div className="cta-feature">
              <span>🎯</span>
              <p>100% Satisfaction Guarantee</p>
            </div>
          </div>
          <div className="cta-actions">
            <a href="https://wa.me/919993143569" className="cta-button whatsapp">
              <span>📱</span> WhatsApp
            </a>
            <a href="tel:+919993143569" className="cta-button call">
              <span>📞</span> Call Now
            </a>
            <button className="cta-button quote"> 
              <span>📝</span> Get Quote
            </button>
            <button className="cta-button work">
              <span>🖼️</span> Our Work
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
